import React from 'react';
import Image from 'common/components/Image';
import Button from 'common/components/Button';
import EnvatoButtonWrapper from './style';

import EnvatoLogo from 'common/assets/image/envato-logo.png';

const EnvatoButton = ({ button }) => {
  return (
    <EnvatoButtonWrapper>
        <a target="_blank" href="https://1.envato.market/c/1309180/275988/4415?u=https%3A%2F%2Fthemeforest.net%2Fitem%2Freact-next-modern-landing-page-template%2F23169879">
          <Image src={EnvatoLogo} alt="Buy Now From Envato" />
          <Button {...button} title="Buy Now" className="envato-buy-button" />
        </a>
    </EnvatoButtonWrapper>
  );
};

EnvatoButton.defaultProps = {
  button: {
    type: 'button',
    fontSize: '14px',
    fontWeight: '600',
    color: '#fff',
    borderRadius: '4px',
    pl: '22px',
    pr: '22px',
    colors: 'primaryWithBg',
  },
};

export default EnvatoButton;
